export const getYearsOld = (date: string): string => {
  return `${new Date().getFullYear() - Number(date.substring(0, 4))} anos`;
};